import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	examName: string;
};

export const SessionReportDisclaimer = ({ examName }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box
			width="100%"
			padding={14}
			gap={8}
			flexDirection="row"
			alignItems="flex-start"
			backgroundColor={theme.colors.secondaryContainer}
			borderRadius={theme.roundness * 3}
		>
			<Box
				width={36}
				height={36}
				borderRadius={18}
				alignItems="center"
				justifyContent="center"
				style={{
					backgroundColor: theme.colors.surfaceVariant,
				}}
			>
				<Icon
					name="information-outline"
					size={24}
					color={theme.colors.onSurfaceVariant}
				/>
			</Box>
			<Box flex={1} gap={8} minWidth={0}>
				<Text
					variant="bodySmall"
					style={{
						color: theme.colors.onSurfaceVariant,
						fontWeight: "600",
					}}
				>
					{t("report.disclaimer.title")}
				</Text>
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{t("report.disclaimer.summativeBody", { examName })}
				</Text>
			</Box>
		</Box>
	);
};
